'use client';

import { useState } from 'react';

import { Stack } from '@backyard-ui/core';

import { type Review } from '@/infra/services/catalog/review/model';

import { GalleryModal } from './GalleryModal';
import { Thumb } from './Thumb';
import { buildMediaItems } from './utils';

export interface MediaItem {
  thumbSrc: string;
  type: 'video' | 'photo';
  alt: string;
  videoId?: string;
}

interface MediasProps extends Pick<Review, 'photos' | 'videos' | 'title'> {
  size?: 'sm' | 'md';
}

function Medias(props: MediasProps) {
  const { photos, videos, title, size } = props;

  const items = buildMediaItems(photos, videos);

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [galleryStartIndex, setGalleryStartIndex] = useState(0);

  return (
    <Stack isWrap spacing="6">
      {items.map(({ alt, thumbSrc, type }, index) => (
        <Thumb
          alt={alt}
          type={type}
          size={size}
          onClick={() => {
            setGalleryStartIndex(index);
            setIsGalleryOpen(true);
          }}
          src={thumbSrc}
          key={index}
        />
      ))}
      <GalleryModal
        isOpen={isGalleryOpen}
        onOpenChange={(prev) => setIsGalleryOpen(prev)}
        title={title}
        startIndex={galleryStartIndex}
        items={items}
      />
    </Stack>
  );
}

export default Medias;
